import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import {
  flexBoxCenter,
  justifyContentFlexStart,
  layerA,
} from '../styles/commonStyles';
import DisplayMachine from './DisplayMachine';
import { useSelector } from 'react-redux';
import { selectEssSwitch } from '../store/slices/essSwitchSlice';
import { selectTesSwitch } from '../store/slices/tesSwitchSlice';
import { selectTgsSwitch } from '../store/slices/tgsSwitchSlice';
import testData from '../../test_data/testData';
import { selectLocations } from '../store/slices/locationsSlice';

const DisplaySpecificLocation = ({
  locationIdx,
  specificLocationIdx,
  location,
  specificLocation,
  handleSelect,
  machinesSpecLocationsLocationsKeys,
  handleOpenMachineOption,
  allLocations,
  selectionMachines,
  openMachineSelect,
  isMachineSelected,
  selectionSpecificLocation,
}) => {

  const [trackOpenSpecificLocation, setTrackOpenSpecificLocation] =
    useState(false);

  const selectIndicatorHandler = () => {
    handleSelect('specific location', locationIdx, null, specificLocationIdx);
  };

  const OpenMachineHandler = () => {
    setTrackOpenSpecificLocation((prev) => !prev);
  };

  return (
    <div>
      <SelectOptions>
        <RadioButton onClick={selectIndicatorHandler}>
          <RadioIndicator
            isSelected={
              selectionSpecificLocation[locationIdx][specificLocationIdx]
            }
          ></RadioIndicator>
        </RadioButton>
        <ArrowButton onClick={OpenMachineHandler}>
          <ArrowImg
            src={
              trackOpenSpecificLocation
                ? '/images/masterCtr-select-btn.svg'
                : 'images/masterCtr-select-btn-right.svg'
            }
          />
        </ArrowButton>

        <Option>{specificLocation.specific_address}</Option>
      </SelectOptions>

      {trackOpenSpecificLocation &&
        machinesSpecLocationsLocationsKeys[location][
          specificLocation.zone_id
        ].map((machine, machineIdx) => (
          <div key={machine.device_mac}>
            <DisplayMachine
              handleSelect={handleSelect}
              isMachineSelected={selectionMachines}
              allLocations={allLocations}
              location={location}
              specificLocation={specificLocation}
              machine={machine}
              locationIdx={locationIdx}
              specificLocationIdx={specificLocationIdx}
              machineIdx={machineIdx}
            />
          </div>
        ))}
    </div>
  );
};

export default DisplaySpecificLocation;

const SelectOptions = styled.div`
  width: 100%;
  height: 27px;

  border: 1px solid #233a54;
  border-radius: 16px;

  ${justifyContentFlexStart}
  padding: 0 2rem;
  margin-bottom: 2rem;

  &:last-child {
    margin-bottom: 0;
  }

  :hover {
    ${layerA}
  }
`;

const RadioButton = styled.button`
  width: 18rem;
  height: 18rem;
  border: 1px solid #95ff45;
  border-radius: 50%;
  ${flexBoxCenter}
`;

const RadioIndicator = styled.div`
  width: 12rem;
  height: 12rem;
  border-radius: 50%;
  background-color: ${(p) => (p.isSelected ? '#95ff45' : 'none')};
`;

const ArrowButton = styled.button`
  ${flexBoxCenter}
  margin-left: 24px;
  height: 100%;
`;

const ArrowImg = styled.img`
  margin-top: 4px;
  height: 55%;
`;

const Option = styled.span`
  font-size: 8px;
  margin-left: 5px;
  ${(p) =>
    p.all &&
    css`
      margin-left: 10px;
    `}

  ${(p) =>
    p.machine &&
    css`
      margin-left: 25px;
    `}
`;
